import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ACHRecord } from 'src/app/models/ach_record.model';
import { Contract } from 'src/app/models/contract.model';
import { ACHRecordService } from 'src/app/services/ach_record_service';
import { ContractService } from 'src/app/services/contract_service.service';
import { CustomerDetailsComponentComponent } from './details-dialog/customer-details-component/customer-details-component.component';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-ach-records',
    templateUrl: './ach-records.component.html',
    styleUrls: ['./ach-records.component.scss'],
    imports: [MatProgressBar, MatTabGroup, MatTab, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatCheckbox, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DatePipe]
})
export class AchRecordsComponent implements OnInit {
    achRecords: ACHRecord[] = [];
    unsignedACHContracts: Contract[] = [];
    savingACHSetUpChange: boolean = false;
    signedDisplayedColumns: string[] = [
        'User',
        'Date Signed',
        'Setup Complete',
        'Details',
    ];
    unsignedDisplayedColumns: string[] = [
        'User',
        'Email Address',
        'Contract Create Date',
    ];

    constructor(
        private achRecordService: ACHRecordService,
        private contractService: ContractService,
        public dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.getAllAchRecords();
    }

    getAllAchRecords(): void {
        this.savingACHSetUpChange = true;
        const map = new Map();
        this.achRecordService.getAll([], map).subscribe((achRecords) => {
            this.achRecords = achRecords;
            let contractTemplateId =
                achRecords[0].contractModel.contractTemplateId;
            this.getAllUnsignedACHContracts(contractTemplateId);
            this.achRecords = achRecords;
            this.savingACHSetUpChange = false;
        }),
            () => {
                this.savingACHSetUpChange = false;
            };
    }

    getAllUnsignedACHContracts(contractTemplateId: string): void {
        let queryParams = new Map([['contractTemplateId', contractTemplateId]]);

        this.contractService
            .getAll([], queryParams)
            .subscribe((unsignedContracts) => {
                unsignedContracts = unsignedContracts.filter(
                    (unsignedContract) =>
                        unsignedContract.approvalStatus == false
                );
                this.unsignedACHContracts = unsignedContracts;
            });
    }

    changeUpdateStatus(achRecord: ACHRecord): void {
        this.savingACHSetUpChange = true;
        achRecord.setupComplete = !achRecord.setupComplete;
        this.achRecordService.put([achRecord.achRecordId], achRecord).subscribe(() => {
                this.getAllAchRecords();
                this.savingACHSetUpChange = false;
            },
            () => {
                this.savingACHSetUpChange = false;
            }
        );
    }

    openDetailsDialog(achRecord: any): void {
        this.dialog.open(CustomerDetailsComponentComponent, {
            width: '700px',
            data: achRecord,
        });
    }
}
